module.exports = __webpack_public_path__ + "img/OddsGalorelogo.4dd60237.png";